<template>
    <div>
        <uzhnet-back-button @click="$router.go(-1)" />

        <div class="header-block location-center">
            <div class="barrier">
                <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M119 1H114L125 11H130L119 1Z" fill="#CACACA" stroke="#CACACA"/>
                        <path d="M114 1H0" stroke="#CACACA"/>
                    </svg>
            </div>
            <div class="label">
                РОЗІГРАШ
            </div>
            <div class="barrier">
                <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 11H18L7 1H2L13 11Z" fill="#CACACA" stroke="#CACACA"/>
                        <path d="M18 11H132" stroke="#CACACA"/>
                    </svg>
            </div>
        </div>
        
        <div class="christmas-gift">  
            <div class="contest-header">
                <div class="contest-header__barrier">
                    <svg width="6" height="108" viewBox="0 0 6 108" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 1H1V107H6" stroke="#B7B7B7" stroke-opacity="0.4" stroke-width="2"/>
                    </svg>
                </div>
                <div class="contest-header__block">
                    <div class="contest-header__content">
                        <div class="contest-header__title">🎄 Привіт, це я — Net!</div>
                        <div class="contest-header__description">Санта вже пакує подарунки, а я вирішив не відставати. Тому <b style="color: #098643; font-family: 'Montserrat';">29.12.2025</b> проведу новорічний розіграш і роздам 10 святкових подарунків нашим чудовим клієнтам Ужнет! 🎁</div>
                    </div>
                </div>
                <div class="contest-header__barrier">
                    <svg width="6" height="108" viewBox="0 0 6 108" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 1H5V107H0" stroke="#B7B7B7" stroke-opacity="0.4" stroke-width="2"/>
                    </svg>
                </div>
            </div>
            <div class="christmas-gift-logo">
                <img src="@/assets/images/christmas-bear-logo.svg" alt="">
            </div>

            <div class="contest-description">
                <div class="contest-description__barrier">
                    <svg width="6" height="303" viewBox="0 0 6 303" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 1H1V302H6" stroke="#B7B7B7" stroke-opacity="0.4" stroke-width="2"/>
                    </svg>
                </div>
                <div class="contest-header__block">
                    <div class="contest-header__content">
                        <div class="contest-header__title">🎉 Хто бере участь?</div>
                        <div class="contest-description__description">
                            Та всі! Серйозно — вам нічого не треба робити. Просто користуйтесь інтернетом від Ужнет і тримайте застосунок під рукою.<br><br>

                            Щоб я зміг додзвонитися до щасливчиків:<br><br>

                            <b style="color: #098643; font-family: 'Montserrat';">•   переконайтесь, що у застосунку вказаний    актуальний номер телефону<br>
                            •   ваш тарифний план має бути активним на момент розіграшу</b><br><br>

                            А далі — справа за мною. Одягну новорічну шапку, ввімкну удачу на максимум і оберу переможців!<br><br>

                            Готуйте місце під подарунки. З вами був Net — ваш другий найбільш веселий персонаж після Санти 😉
                        </div>
                    </div>
                </div>
                <div class="contest-description__barrier">
                    <svg width="6" height="304" viewBox="0 0 6 304" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M-9.16752e-08 1H5V303H-9.16752e-08" stroke="#B7B7B7" stroke-opacity="0.4" stroke-width="2"/>
                    </svg>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    name: "ChristmasGift",
}
</script>
<style lang="scss" scoped>
    .contest-header {
        display: flex;

        &__block {
            background: rgba(183, 183, 183, 0.05);
            backdrop-filter: blur(5px);
            padding: 10px 0;
        }

        &__title {
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 700;
            font-size: 14px;
            color: #FFFFFF;
            text-align: center;
        }

        &__description {
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            color: #FFFFFF;
            text-align: center;
            margin-top: 8px;
        }

        &__barrier {
            scale: 1.1;
            position: relative;
            top: 3.5px;
        }
    }

    .contest-description {
        display: flex;
        position: relative;
        top: -50px;

        &__description {
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            color: #FFFFFF;
            text-align: start;
            margin-top: 8px;
            padding: 0 10px;
        }

        &__barrier {
            scale: 1.12;
            position: relative;
            top: 16px;
        }
    }

    .christmas-gift {
        width: 100%;
        height: 83%;
        padding: 20px;

        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: start;
    }

    .christmas-gift-logo {
        width: 100%;
    }

    .christmas-gift-logo img {
        display: block;
        margin: 0 auto;
        width: 60%;
        height: auto;
    }

</style>